"use client";

import {JSX} from "react";

import {SpaceProps, useSectionSpace} from "@/sections/use-section-space";

import {ContainerBase} from "@/shared/ui/layout/container-base";
import {LocationMap, LocationMapProps} from "@/shared/ui/maps/google-location-map/location-map";

import {ArticlePart, ArticlePartProps} from "./article-part";

import "./text-map-section.scss";

export type TextMapArticle = ArticlePartProps;

export type TextMapSectionProps = {
    articles: Array<TextMapArticle>;
    map: Omit<LocationMapProps, "className">;
    space?: SpaceProps;
    className?: string;
};

export function TextMapSection({articles, map, space, className = ""}: TextMapSectionProps): JSX.Element | null {
    const sectionVars = useSectionSpace(space);

    if (!articles?.length) return null;

    return (
        <section className={`text-map-section ${className}`} style={sectionVars}>
            <ContainerBase>
                <div className="text-map-section__grid">
                    <div className="text-map-section__left">
                        {articles.map((item, index) => (
                            <ArticlePart key={`${item.title}-${index}`} {...item} />
                        ))}
                    </div>
                    <div className="text-map-section__right">
                        <LocationMap {...map} className="text-map-section__map" />
                    </div>
                </div>
            </ContainerBase>
        </section>
    );
}
